(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dag-matisse-frame-media"] && !Shopify.designMode) return;
  try {
    (function() {
  function normalizeFinish(value) {
    const parts = String(value || '').split('/');
    return String(parts[parts.length - 1] || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function finishFromVariant(variant, fallbackTitle) {
    if (variant && Array.isArray(variant.options) && variant.options.length > 1) {
      return normalizeFinish(variant.options[1]);
    }
    return normalizeFinish((variant && variant.title) || fallbackTitle || '');
  }

  function isSupportedFinish(finish) {
    return (
      finish === 'unframed' ||
      finish === 'museum-black' ||
      finish === 'natural-oak' ||
      finish === 'soft-white'
    );
  }

  function setFinish(root, finish) {
    if (!root || !isSupportedFinish(finish)) return;
    root.dataset.selectedFinish = finish;
    root.querySelectorAll('[data-frame-photo]').forEach(function(photo) {
      photo.classList.toggle('is-active', photo.dataset.framePhoto === finish);
    });
  }

  function findRoot(target) {
    const product = target && target.closest ? target.closest('loess-product') : null;
    return product ? product.querySelector('[data-dag-matisse-media]') : document.querySelector('[data-dag-matisse-media]');
  }

  document.addEventListener('change', function(event) {
    const target = event.target;
    if (!target || !target.matches('select,input[type="radio"]')) return;

    const root = findRoot(target);
    if (!root) return;

    const finish = normalizeFinish(target.value);
    if (isSupportedFinish(finish)) setFinish(root, finish);
  }, true);

  ['product:variant:changed', 'variant:change', 'variant-change', 'product:variant-change'].forEach(function(name) {
    document.addEventListener(name, function(event) {
      const detail = event && event.detail ? event.detail : {};
      const variant = detail.variant || {};
      const root = findRoot(event.target || document.body);
      if (!root) return;

      const finish = finishFromVariant(variant, detail.title || '');
      if (isSupportedFinish(finish)) setFinish(root, finish);
    });
  });

  document.addEventListener('click', function(event) {
    const open = event.target.closest('[data-dag-open-artwork]');
    if (open) {
      const root = open.closest('[data-dag-matisse-media]');
      const dialog = root ? root.querySelector('[data-dag-artwork-dialog]') : null;
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }

    const close = event.target.closest('[data-dag-close-artwork]');
    if (close) {
      const dialog = close.closest('dialog');
      if (dialog) dialog.close();
    }
  });

  document.addEventListener('click', function(event) {
    const dialog = event.target;
    if (dialog && dialog.matches && dialog.matches('[data-dag-artwork-dialog]') && event.target === dialog) {
      dialog.close();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dag-matisse-presentation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dag-matisse-details')) {
  customElements.define('dag-matisse-details', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.media = this.closest('loess-product')?.querySelector('[data-dag-matisse-media]');
      this.form = this.querySelector('form');
      this.form?.addEventListener('change', event => {
        if (event.target.matches('input[name="id"]')) this.select(event.target, true);
      }, { signal });
      this.media?.querySelectorAll('[data-matisse-view]').forEach(button => {
        button.addEventListener('click', () => this.selectPresentationView(button.dataset.matisseView), { signal });
      });
      this.media?.querySelectorAll('[data-curated-select]').forEach(button => {
        button.addEventListener('click', () => this.selectCurated(button), { signal });
      });
      const dialog = this.media?.querySelector('.dag-matisse-dialog');
      const enquiryDialog = this.querySelector('[data-matisse-enquiry-dialog]');
      this.querySelector('[data-matisse-contact]')?.addEventListener('click', () => enquiryDialog?.showModal(), { signal });
      this.querySelector('[data-matisse-enquiry-close]')?.addEventListener('click', () => enquiryDialog?.close(), { signal });
      enquiryDialog?.addEventListener('click', event => { if (event.target === enquiryDialog) enquiryDialog.close(); }, { signal });
      this.media?.querySelector('[data-matisse-zoom]')?.addEventListener('click', () => {
        const source = this.activeMediaImage();
        const dialogImage = dialog?.querySelector('[data-matisse-dialog-image]');
        if (source && dialogImage) {
          dialogImage.src = source.currentSrc || source.src;
          dialogImage.alt = source.alt || '';
        }
        dialog?.showModal();
      }, { signal });
      dialog?.querySelector('[data-matisse-close]')?.addEventListener('click', () => dialog.close(), { signal });
      window.addEventListener('popstate', () => {
        const id = new URL(window.location.href).searchParams.get('variant');
        const radios = [...this.querySelectorAll('input[name="id"]')];
        const input = radios.find(radio => radio.value === id) || radios[0];
        if (input) { input.checked = true; this.select(input, false); }
      }, { signal });
      const input = this.querySelector('input[name="id"]:checked');
      if (input) this.select(input, false);
    }
    disconnectedCallback() { this.controller?.abort(); this.bound = false; }
    select(input, updateURL) {
      this.querySelector('[data-matisse-price]').textContent = input.dataset.price;
      this.querySelector('[data-matisse-selected]').textContent = input.dataset.label;
      const delivery = this.querySelector('[data-matisse-delivery]');
      if (delivery) delivery.textContent = input.dataset.finish === 'unframed' ? delivery.dataset.unframed : delivery.dataset.framed;
      const button = this.querySelector('[name="add"]');
      button.disabled = input.disabled;
      button.querySelector('span').textContent = input.disabled ? button.dataset.unavailableLabel : button.dataset.availableLabel;
      if (this.media) {
        this.media.dataset.finish = input.dataset.finish;
        this.clearCurated(input.dataset.finish);
        if (input.dataset.finish === 'unframed') {
          this.setView('artwork');
        } else {
          this.setView('framed');
        }
      }
      const enquiryPresentation = this.querySelector('[data-matisse-enquiry-presentation]');
      if (enquiryPresentation) enquiryPresentation.value = input.dataset.label;
      if (updateURL) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState(window.history.state, '', url);
      }
    }
    selectPresentationView(view) {
      const radios = [...this.querySelectorAll('input[name="id"]')];
      if (view === 'artwork') {
        const input = radios.find(radio => radio.dataset.finish === 'unframed' && !radio.disabled);
        if (input) {
          input.checked = true;
          this.select(input, true);
          return;
        }
      }
      if (view === 'framed' && this.media?.dataset.finish === 'unframed') {
        const input = radios.find(radio => radio.dataset.finish === 'museum-black' && !radio.disabled)
          || radios.find(radio => radio.dataset.finish === 'natural-oak' && !radio.disabled)
          || radios.find(radio => radio.dataset.finish !== 'unframed' && !radio.disabled);
        if (input) {
          input.checked = true;
          this.select(input, true);
          return;
        }
      }
      if (view === 'framed') this.clearCurated(this.media?.dataset.finish);
      this.setView(view);
    }
    selectCurated(button) {
      const view = button.dataset.curatedSelect;
      const finish = button.dataset.curatedFinish;
      const radios = [...this.querySelectorAll('input[name="id"]')];
      if (finish) {
        const input = radios.find(radio => radio.dataset.finish === finish && !radio.disabled);
        if (input && !input.checked) {
          input.checked = true;
          this.select(input, true);
        }
      }
      if (view === 'artwork') {
        this.setView('artwork');
      } else {
        this.setCuratedView(view, finish);
        this.setView('framed');
      }
    }
    clearCurated() {
      if (!this.media) return;
      this.media.querySelectorAll('.dag-matisse-curated-image.is-active').forEach(item => item.classList.remove('is-active'));
      this.media.querySelectorAll('[data-curated-select]').forEach(button => button.setAttribute('aria-pressed', 'false'));
    }
    setCuratedView(view, finish) {
      if (!this.media) return;
      const activeFinish = finish || this.media.dataset.finish;
      this.media.querySelectorAll('[data-curated-finish]').forEach(group => {
        if (!group.classList.contains('dag-matisse-curated-preview')) return;
        group.querySelectorAll('[data-curated-view]').forEach(item => item.classList.toggle('is-active', group.dataset.curatedFinish === activeFinish && item.dataset.curatedView === view));
      });
      this.media.querySelectorAll('[data-curated-tools]').forEach(group => {
        group.querySelectorAll('[data-curated-select]').forEach(button => button.setAttribute('aria-pressed', String(group.dataset.curatedTools === activeFinish && button.dataset.curatedSelect === view)));
      });
    }
    activeMediaImage() {
      if (!this.media) return null;
      if (this.media.dataset.view === 'artwork') return this.media.querySelector('.dag-matisse-artwork-preview img');
      const curated = this.media.querySelector('.dag-matisse-curated-preview[data-curated-finish="' + this.media.dataset.finish + '"] .dag-matisse-curated-image.is-active img');
      if (curated) return curated;
      const primary = this.media.querySelector('.dag-matisse-primary-preview[data-primary-finish="' + this.media.dataset.finish + '"] img');
      if (primary) return primary;
      return this.media.querySelector('.dag-matisse-frame img') || this.media.querySelector('.dag-matisse-artwork-preview img');
    }
    setView(view) {
      if (!this.media) return;
      this.media.dataset.view = view;
      this.media.querySelectorAll('[data-matisse-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.matisseView === view)));
      const measurement = this.media.querySelector('[data-matisse-measurement]');
      if (measurement) measurement.textContent = measurement.dataset[view];
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
